export const HEADING_A = 'heading_a';
export const THICKNESS_A = 'thickness_a';
export const WIDTH_A = 'width_a';
export const LENGTH = 'length';
export const QUANTITY_A = 'quantity_a';
export const HEADING_B = 'heading_b';
export const THICKNESS_B = 'thickness_b';
export const WIDTH_B = 'width_b';
export const QUANTITY_B = 'quantity_b';
export const QUANTITY_UNITS = 'units';
export const UNITS_CAPTION = 'unitsCaption';
export const THICKNESS_A_DEFAULT = 'thicknessA';
export const THICKNESS_A_CAPTION = 'thicknessACaption';
export const WIDTH_A_DEFAULT = 'widthA';
export const WIDTH_A_CAPTION = 'widthACaption';
export const THICKNESS_B_DEFAULT = 'thicknessB';
export const THICKNESS_B_CAPTION = 'thicknessBCaption';
export const WIDTH_B_DEFAULT = 'widthB';
export const WIDTH_B_CAPTION = 'widthBCaption';
export const LENGTH_DEFAULT = 'length';
export const LENGTH_CAPTION = 'lengthCaption';
